import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import NurseryReport from 'src/views/Pages/Dashboard/SowingReports/NurseryReport/Report.vue';
import SowingReport from 'src/views/Pages/Dashboard/SowingReports/SowingReport/Report.vue';
import PruningReport from 'src/views/Pages/Dashboard/SowingReports/PruningReport/Report.vue';
import SummaryReport from 'src/views/Pages/Dashboard/SowingReports/SummaryReport/Report.vue';
import InventoryReport from 'src/views/Pages/Dashboard/SowingReports/InventoryReport/Report.vue';

const ReportsRoutes = {
    path: 'reports',
    name: 'sowing.reports',
    component: MasterTab,
    props: { reference: 'reportsTabs' },
    children: [
        {
            path: 'reportnursery',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'sowing.nursery_reports',
                    component: NurseryReport,
                    meta: {
                        prefix_permission: 'reports_reportnursery',
                    },
                },
            ],
        },
        {
            path: 'reportsowing',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'sowing.sowing_reports',
                    component: SowingReport,
                    meta: {
                        prefix_permission: 'reports_reportsowing',
                    },
                },
            ],
        },
        {
            path: 'reportpruning',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'sowing.pruning_reports',
                    component: PruningReport,
                    meta: {
                        prefix_permission: 'reports_reportpruning',
                    },
                },
            ],
        },
        {
            path: 'reportsummary',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'sowing.summary_reports',
                    component: SummaryReport,
                    meta: {
                        prefix_permission: 'reports_reportsummary',
                    },
                },
            ],
        },
        {
            path: 'reportinventory',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'sowing.inventory_reports',
                    component: InventoryReport,
                    meta: {
                        prefix_permission: 'reports_reportinventory',
                    },
                },
            ],
        },
    ]
}

export default ReportsRoutes;